<template>
  <v-navigation-drawer
    v-if="getData"
    class="white pa-0"
    v-model="barOpen"
    dark
    hide-overlay
    right
    floating
    absolute
    :width="barOpen ? barSize : 0"
    disable-resize-watcher
  >
    <scroll-area>
      <template slot="header">
        <v-layout column  justify-start pa-0>
          <v-layout style="height: 60px" align-center  ml-0 mb-0 mt-0 pa-2>
            <v-tabs
                light
                v-model="panel"
                height="40px"
                left
              >
              <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>
                <v-tab
                    class="font-weight-normal"    
                    v-for="(place, index) in getPlaces"
                    :key="index"
                  >
                  <template slot="default">
                    <div class="tab_wrapper">
                      <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                        {{ $t(place) }} 
                      </div>
                    </div>
                  </template>
                </v-tab>
            </v-tabs>

            <v-layout fill-height justify-end align-center>
              <v-menu v-if="getPlaces[panel] == 'inventory' && getData.cls == 'device' && !editInventory"
                v-model="moveDeviceDialog"
                :close-on-content-click="false"
                nudge-bottom="-40"
                nudge-left="150"
                min-width="400"
                bottom
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-tooltip dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'replace'" icon flat slot="activator" v-on="on">
                      <svg-icon
                        :color="'grey'"
                        :name="'move'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('replace') }}</span>
                  </v-tooltip>
                </template>

                <device-replacing
                  @load-devices="() => onDeviceReplacingLoadDevices()"
                  @close="moveDeviceDialog = false"
                  :menu-visible="moveDeviceDialog"
                />
              </v-menu>

              <v-tooltip v-if="getPlaces[panel] == 'configuration' && !editInventory" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'onEdit-configuration'" icon flat slot="activator" @click="() => onEdit('configuration')" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'grey'"
                    :name="'edit'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('edit') }}</span>
              </v-tooltip>

              <v-tooltip v-if="getPlaces[panel] == 'inventory' && !editInventory && getData.cls != 'slot'" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'emit-remove'" icon flat slot="activator" v-if="getData.cls != 'slot'" @click.stop="() => {$emit('remove', getData)}" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'red'"
                    :name="'basket'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('remove') }}</span>
              </v-tooltip>

              <v-tooltip v-if="getPlaces[panel] == 'inventory' && getData.cls == 'slot' && checkOpenSlot(getData)" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'emit-add'" small icon flat slot="activator" @click.stop="() => {$emit('add', getData)}" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'green'"
                    :name="'add'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('add') }}</span>
              </v-tooltip>

              <v-tooltip v-if="getPlaces[panel] == 'inventory' && !editInventory && getData.cls != 'slot'" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'onEdit-inventory'" icon flat slot="activator" @click="() => onEdit('inventory')" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'grey'"
                    :name="'edit'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('edit') }}</span>
              </v-tooltip>

              <v-tooltip v-if="editInventory" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'update'" v-if="editInventory" icon flat slot="activator" @click="() => update()" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'green'"
                    :name="'done'"
                    width="20"
                  />
                </v-btn>
                <span v-if="editInventory">{{ $t('save') }}</span>
              </v-tooltip>

              <v-tooltip v-if="!editInventory" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'close'" v-if="!editInventory" icon flat slot="activator" @click="() => close()" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'grey'"
                    :name="'close'"
                    width="20"
                  />
                </v-btn>
                <span v-if="!editInventory">{{ $t('close') }}</span>
              </v-tooltip>

              <v-tooltip v-if="editInventory" dark color="secondary" bottom>
                <v-btn :data-testid="$options.name + 'v-btn' + 'closeEdit'" v-if="editInventory" icon flat slot="activator" @click="() => closeEdit()" :disabled="moveDeviceDialog">
                  <svg-icon
                    :color="'grey'"
                    :name="'close'"
                    width="20"
                  />
                </v-btn>
                <span v-if="editInventory">{{ $t('cancel') }}</span>
              </v-tooltip>
            </v-layout>
          </v-layout>
        </v-layout>
      </template>

      <template slot="body">
        <v-container fluid fill-height ma-0 pa-0>
          <v-layout column fill-height>
            <v-form ref="location-form" style="height: 100%">
              <v-layout column v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height pa-1 ma-0>
                <v-layout column v-if="place == 'configuration'" style="position: relative" fill-height>
                  <configuration 
                    ref="configuration"
                    :data="getData"
                  />
                </v-layout>

                <v-layout column v-if="place == 'inventory'" style="position: relative" fill-height>
                  <inventory
                    ref="inventory"
                    :data="getData"
                    :meta="getMeta"
                    :model="getModel"
                    :cabinet="cabinet"
                    :closedUnits="closedUnits"
                    :edit="editInventory"
                  /> 
                </v-layout>

                <v-layout column v-if="place == 'console'" style="position: relative" fill-height>
                  <console
                    ref="console"
                    :data="getData"
                  />    
                </v-layout>

                <v-layout column v-if="place == 'manage'" style="position: relative" fill-height>
                  <manage-device 
                    :data="getData"
                    :template="getTemplate"
                    @update="(payload) => {$emit('update', payload)}"
                  />
                </v-layout>

                <v-layout column v-if="place == 'params'" ref="inventory_bar_wrapper" style="position: relative" fill-height>
                  <equipment-table
                    :data="getData"
                    :devices="getCabinet"
                    :editeble="false"
                    :updater="equipmentTableUpdateCounter"
                    @chart="(payload)=>{onChartSelect(payload)}"
                    @value="(payload)=>{rulesOpen(payload)}"
                  />
                </v-layout>
              </v-layout>
            </v-form>
          </v-layout>

          <v-dialog v-model="dialog.chart.open" max-width="50%" v-if="dialog.chart.open">
            <chart-card
              v-if="dialog.chart.open"
              :data="measure"
              :equipment="getData"
              @close="() => {
                dialog.chart.open = false
              }"
            />
          </v-dialog>

          <v-dialog persistent v-model="dialog.rules.open" max-width="600px" v-if="dialog.rules.open">
            <rules-table
              :row="dialog.rules.row"
              :ref-id="getData && getData.ref_id"
              @close="() => {dialog.rules.open = false}"
              @updateMeasures="() => {equipmentTableUpdateCounter++}"
              @loadDevice="() => {$emit('loadDevice')}"
              @polling="() => {$emit('polling')}"
            />
          </v-dialog>

        </v-container>
      </template>
    </scroll-area>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import equipmentTable from '@/nms/pages/equipment/equipment-table.vue'
import Configuration from '@/nms/components/device-configuration/configuration/configuration.vue'
import Console from '@/nms/components/device-configuration/console/console.vue'
import ManageDevice from '@/nms/components/device-configuration/manage/manage-device.vue'
import rulesTable from '@/nms/pages/equipment/rules-table.vue'
import chartCard from '@/nms/pages/equipment/chart-card.vue'
import Inventory from '@/nms/components/equipment/inventory.vue'
import DeviceReplacing from '@/nms/pages/device/device-replace-choose.vue'
import { getURL } from '@/nms/plugins/bridge.js'

// Типы
interface TreeNode {
  $id?: string
  children?: TreeNode[]
  slot_size?: number
  [key: string]: any
}

interface TemplateData {
  tree?: any
  bridges?: {
    ssh?: any
    vinteo?: any
    [key: string]: any
  }
  monitoring?: Array<{ id: string }>
  [key: string]: any
}

interface TunnelData {
  protocol?: string;
  port: number;
}

interface FileItem {
  id?: string
  data?: {
    description?: string
    [key: string]: any
  }
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
  image: any | null
}

interface DialogState {
  chart: { open: boolean }
  rules: { open: boolean; row: any | null }
}

interface ViewState {
  places: string[]
}

interface EquipmentData {
  $id?: string
  [key: string]: any
}

interface MetaData {
  bridges?: {
    ssh?: any
  }
  [key: string]: any
}

export default Vue.extend({
  name: 'EQUIPMENT_TREE_BAR',

  components: {
    scrollArea,
    svgIcon,
    equipmentTable,
    Configuration,
    Console,
    ManageDevice,
    rulesTable,
    chartCard,
    Inventory,
    DeviceReplacing,
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    selectedMeta: {
      type: Object as () => MetaData,
      default: () => ({})
    },
    template: {
      type: Object as () => TemplateData,
      default: () => ({})
    },
    cabinet: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
  },

  data(): {
    currentActive: EquipmentData | null
    barOpen: boolean
    barSize: number
    panel: number
    view: ViewState
    editInventory: boolean
    moveDeviceDialog: boolean
    equipmentTableUpdateCounter: number
    measure: any | null
    dialog: DialogState
    model: ModelData
    state: { messages: { error: string } }
    webaccess: string | null
    area: string
    files: FileItem[]
    meta: MetaData
    preview: boolean
  } {
    return {
      currentActive: null,
      barOpen: false,
      barSize: 0,
      panel: 0,
      view: {
        places: ['params', 'console', 'manage', 'vinteo', 'configuration', 'inventory'],
      },
      editInventory: false,
      moveDeviceDialog: false,
      equipmentTableUpdateCounter: 0,
      measure: null,
      dialog: {
        chart: { open: false },
        rules: { open: false, row: null },
      },
      model: {
        fields: {},
        items: {},
        obj: {},
        image: null,
      },
      state: {
        messages: { error: '' }
      },
      webaccess: null,
      area: 'plan',
      files: [],
      meta: {},
      preview: false,
    }
  },

  computed: {
    getData(): EquipmentData {
      return this.data
    },
    getMeta(): MetaData {
      return this.meta
    },
    getFields(): Record<string, any> {
      return this.model.fields || {}
    },
    getModel(): ModelData {
      return this.model || {} as ModelData
    },
    getSelectedMeta(): MetaData {
      return this.selectedMeta
    },
    getTemplate(): TemplateData {
      return this.template
    },
    getCabinet(): any {
      return this.$store.state.devices.devices
    },
    getPlaces(): string[] {
      let places = this.$store.getters.getEquipmentNails.tree.bar.view.places
      
      if (!this.getSelectedMeta?.bridges?.ssh) {
        places = places.filter((place: string) => place !== 'console' && place !== 'manage')
      }
      if (!this.getTemplate?.webaccess) {
        places = places.filter((place: string) => place !== 'webaccess')
      }
      if (!this.getTemplate?.tree) {
        places = places.filter((place: string) => place !== 'manage')
      }
      if (!this.getTemplate?.bridges?.hasOwnProperty('vinteo')) {
        places = places.filter((place: string) => place !== 'vinteo')
      }
      console.log(this.$options.name, 'getPlaces', 'places', places)
      return places
    },
    getPlan(): FileItem[] {
      if (!this.files.length) return []
      return this.files.filter(file => file.data?.description === 'image_$')
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        const wrapper = this.$parent.$refs['equipment_tree_wrapper'] as HTMLElement
        if (wrapper) {
          this.barSize = wrapper.clientWidth * 0.75
        }
        this.barOpen = newVal
      },
      deep: true
    },
    data: {
      handler(newVal: EquipmentData, oldVal: EquipmentData): void {
        // console.log('WATCH', this.$options.name, 'data JSON', JSON.parse(JSON.stringify(newVal)))
        if (!newVal?.$id) return
        // if (newVal.$id === this.currentActive?.$id) return
        if (this.open) {
          this.setup('watch data')
          this.currentActive = newVal
        }
      },
      deep: true
    },
    panel: {
      handler(newVal: string): void {
        this.moveDeviceDialog = false
        if(this.getPlaces[newVal] == 'webaccess') {
          this.getWebaccess()
        }
      },
      deep: true
    },
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)
  },

  updated(): void {
    if (this.open) {
      const wrapper = this.$parent.$refs['equipment_tree_wrapper'] as HTMLElement
      if (wrapper) {
        this.barSize = wrapper.clientWidth * 0.75
      }
      this.barOpen = true
    }
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
    this.moveDeviceDialog = false
  },

  methods: {
    setup(caller: string): void {
      this.moveDeviceDialog = false
      this.reset()
      if (this.getData) {
        this.loadFiles()
        this.loadMeta(caller)
        this.area = 'map'
      }
    },

    async loadMeta(caller: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(this.getData, false, this.$options.name)
        console.log(this.$options.name, 'loadMeta', 'caller', caller, 'this.meta', this.meta)
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
      }
    },

    async prepareData(obj?: any): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        // console.log(this.$options.name, 'prepareData', 'model JSON', JSON.parse(JSON.stringify(model)))
        this.model = model
      } catch (error) {
        this.setLoader('loadMeta', false)
      }
    },

    async loadFiles(): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getData.$id)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async update(): Promise<void> {
      const inventoryRef = this.$refs['inventory'] as any[]
      const valid = inventoryRef?.[0]?.validateForm?.() ?? false
      
      if (!valid) {
        this.$dialog.notify.error(this.$getTranslate(this.state.messages.error), {
          timeout: 1000
        })
        return
      }
      if (this.$store.state.auth.lock) return

      try {
        this.$store.state.auth.lock = true
        const data_$ = { ...this.model.obj }
        console.log(this.$options.name, 'update', 'data_$', data_$)

        const data$: Record<string, any> = {}
        Object.keys(data_$).forEach(key => {
          data$[key] = data_$[key] === undefined ? null : data_$[key]
        })
        
        if (this.model.image) {
          if (this.getPlan.length) {
            await this.$bridge.deleteDocument(this.getPlan[0].id)
          }
          data$.files = this.model.image
        }
        console.log(this.$options.name, 'update', 'data$', data$)

        this.setLoader('updateDeviceInventory', true)
        const $obj = await this.$bridge.getObjectById(this.getData.$id)
        console.log(this.$options.name, 'update', '$obj', $obj)
        
        if ($obj) {
          const u = await $obj.update(data$)
          console.log(this.$options.name, 'update', 'u', u)
          if (u) {
            this.$dialog.notify.success('Успешно обновлено', { timeout: 5000 })
            this.$bridge.litePolling(u.$id)
            this.$emit('update', u)
            this.setLoader('updateDeviceInventory', false)
            this.editInventory = false
            await this.$store.dispatch('updateObject', { $id: this.getData.$id })
            this.$store.state.auth.lock = false
          } else {
            console.log(this.$options.name, 'update', 'smth wrong', u)
            this.setLoader('updateDeviceInventory', false)
            await this.$store.dispatch('updateObject', { $id: this.getData.$id })
            this.$store.state.auth.lock = false
          }
        } else {
          console.log(this.$options.name, 'update', '$obj', 'smth wrong', $obj)
          this.setLoader('updateDeviceInventory', false)
          this.$store.state.auth.lock = false
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'update', err)
        this.$errorHandler(err)
        this.setLoader('updateDeviceInventory', false)
        this.$store.state.auth.lock = false
      }
    },

    checkForm(name: string): boolean {
      console.log(this.$options.name, 'checkForm', 'this.$refs[name]', this.$refs[name])
      const ref = this.$refs[name] as any
      return ref ? ref.validateForm() : false
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
        this.close()
      }
    },

    resizeHandler(e: UIEvent): void {
      const wrapper = this.$parent.$refs['equipment_tree_wrapper'] as HTMLElement
      if (wrapper) {
        this.barSize = wrapper.clientWidth * 0.75
      }
    },

    close(): void {
      console.log(this.$options.name, 'close', 'started')
      this.editInventory = false
      this.reset()
      this.$emit('close')
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    onChartSelect(measure: any): void {
      if (!measure) return
      if (measure.mirror?.type === 'number') {
        this.measure = measure
        this.dialog.chart.open = !this.dialog.chart.open
      }
    },

    rulesOpen(rowData: any): void {
      if (this.$store.state.auth.user?.level === 0) {
        console.log('message filed!')
        console.log('rulesOpen', rowData)
        this.dialog.rules = { open: true, row: rowData }
      }
    },

    onEdit(val: string): void {
      console.log(this.$options.name, 'onEdit', 'val', val)
      if (val === 'configuration') {
        this.$emit('configurationEdit', this.getData)
      }
      if (val === 'inventory') {
        this.editInventory = true
      }
    },

    checkOpenSlot(item: TreeNode | null): boolean {
      console.log(this.$options.name, 'checkOpenSlot', 'item', item)
      if (!item) return false
      if (item.children) {
        if (!item.children.length) return true
        if (item.children.length && item.children.length < (item.slot_size || 0)) return true
        return false
      }
      return false
    },

    onDeviceReplacingLoadDevices(): void {
      this.moveDeviceDialog = false
      this.$emit('deviceReplacingLoadDevices')
    },

    closeEdit(): void {
      this.editInventory = false
    },

    async getWebaccess(): Promise<string | undefined> {
      const isLocalhost: boolean = [
        'localhost',
        '[::1]'
      ].includes(window.location.hostname) || 
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(window.location.hostname)
      console.log(this.$options.name, 'getWebaccess', 'this.getData', this.getData)
      // Ранний возврат, если нет доступа
      if (!this.getData.webaccess) {
        return undefined
      }

      const tunnelData: TunnelData | null = await this.$bridge.createWebUiTunnel(this.getData.$id)
      console.log(this.$options.name, 'getWebaccess', 'tunnelData', tunnelData)
      if (!tunnelData) {
        return undefined
      }

      console.log('SHOW_DEVICE_BAR', 'getWebaccess', 't', tunnelData)

      let webaccessUrl: string

      if (isLocalhost) {
        const protocol: string = tunnelData.protocol || 'https'
        const ip: string = protocol === 'http' ? getURL('devServer') : getURL('httpsDevServer')
        webaccessUrl = `${ip}:${tunnelData.port}`
      } else {
        const url: URL = new URL('/', window.location.href)
        url.protocol = tunnelData.protocol || 'https'
        url.port = String(tunnelData.port)
        webaccessUrl = url.href
      }

      console.log('SHOW_DEVICE_BAR', 'getWebaccess', 'string', webaccessUrl)
      
      this.webaccess = webaccessUrl
      window.open(webaccessUrl, "_blank")
      
      return webaccessUrl
    },

    reset(): void {
      this.panel = 0
      this.model = {
        fields: {},
        items: {},
        obj: {},
        image: null
      }
      this.area = 'plan'
      this.files = []
      this.equipmentTableUpdateCounter = 0
      this.measure = null
      this.editInventory = false
    },
  },
})
</script>

<style lang="css" scoped>

  .toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
  }

</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
